import { MoneyValueDto } from '@/types/MoneyValueDto.ts';
import {
  PublicTransportPriceDto,
  PublicTransportVariantDto,
} from '@/features/public/booking/types/PublicTransportSelectorDto.ts';

/**
 * Picks the price row that applies to a participant of the given age.
 *
 * A variant is either a single flat row (`ageRange === null`) or several
 * non-overlapping age brackets. Flat rows always apply; otherwise the row whose
 * `ageRange` covers `age` is returned. Returns `undefined` when no bracket fits.
 */
export const findTransportPriceForAge = (
  variant: PublicTransportVariantDto,
  age: number,
): PublicTransportPriceDto | undefined => {
  const flat = variant.prices.find((p) => p.ageRange == null);
  if (flat) return flat;

  return variant.prices.find((p) => {
    const range = p.ageRange;
    if (!range) return true;
    const aboveMin = range.minAge == null || age >= range.minAge;
    const belowMax = range.maxAge == null || age <= range.maxAge;
    return aboveMin && belowMax;
  });
};

/** Adapts a transport price + variant currency into a reusable `MoneyValueDto`. */
export const transportPriceToMoney = (
  price: PublicTransportPriceDto,
  currency: string,
): MoneyValueDto => ({
  amount: price.amount,
  currency,
});
